import { useCallback, useEffect, useState } from 'react'

import useRedux from '../../../hooks/useRedux'
import useTranslations from '../../../hooks/useTranslations'
import { setPopupMessageModel } from '../../../redux/app/reducer'
import { setOptionsList } from '../../../redux/jobs/reducer'
import { useFormFn } from '../../../shared/antd/ANTDForm'
import { apiParams } from '../../../utils'
import { userWiseRole } from '../../../utils/constant'
import { numberFormatting } from '../../../utils/customFunctions'
import { dayJs, SAVE_FORMAT } from '../../../utils/dayjs'
import debounce from '../../../utils/debounce'
import {
  entries,
  include,
  isEqual,
  keys,
  length,
  notEqual,
} from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import {
  getVehicleModelListApi,
  searchVehicleModelListApi,
} from '../../jobs/jobs.api'
import {
  getAddressDataListApi,
  getTagListApi,
  getUserList,
  searchUserApi,
} from '../../userManagement/user.api'
import {
  exportToExcelApi,
  getColumnListApi,
  getFlexibleReportCalculationApi,
  getFlexibleReportDataApi,
  saveFlexibleReportApi,
} from '../report.api'
import { filterKeys } from '../report.description'

const createReport = ({ editData }) => {
  const { t } = useTranslations()
  const fmtNum = rowData => numberFormatting(rowData) || '-'
  const { dispatch, selector } = useRedux()
  const adminId = getItem('adminId')
  const form = useFormFn()
  const { producer, dealer } = userWiseRole
  const {
    vehicleCategory,
    vehicleProducer,
    vehicleModel,
    vehicleSource,
    vehicleType,
    vehicleStatus,
    rcAvailability,
    beneficiary,
    dealerName,
    dealerLocation,
    dealerChannel,
    dateFilter,
    jobCompleted,
  } = filterKeys
  const {
    vehicleCategoryList = [],
    scrapSourceList = [],
    elvSourceList = [],
    producerList = {},
    dealerList = {},
    locationList = [],
    channelList = [],
  } = selector(state => state?.jobs?.options)

  const [viewPreviousHistory, setViewPreviousHistory] = useState({
    open: false,
    data: [],
  })
  const [modal, setModal] = useState({ open: false })
  const [selectedFilters, setSelectedFilters] = useState({})
  const [equalNotEqual, setEqualNotEqual] = useState({
    [vehicleProducer]: true,
    [vehicleModel]: true,
    [dealerName]: true,
    [dealerLocation]: true,
  })
  const [columnList, setColumnList] = useState([])
  const [columnFilters, setColumnFilters] = useState([])
  const [flexibleReportData, setFlexibleReportData] = useState({})
  const [vehicleModelData, setVehicleModelData] = useState({ list: [] })
  const [flexibleReportCalculation, setFlexibleReportCalculation] = useState({})
  const [calculationTag, setCalculationTag] = useState({})

  useEffect(() => {
    columnListApi()
    getVehicleModelList({})
    if (editData) {
      setEditDataToFilters()
      getFlexibleReportAPI({
        apiPayload: { flexibleReportId: editData?.id },
      })
    } else {
      tagAPIFn()
      getProducerListAPI()
      getDealerListAPI()
      getFlexibleReportAPI({ data: selectedFilters })
      getLocationAPI()
    }
  }, [editData])

  const setEditDataToFilters = () => {
    if (!length(keys(editData))) return

    //set this when edit functionality is needed
    // form.setFieldsValue({
    //   name: editData.name,
    //   description: editData.description,
    // })

    ///////-------------------------------///////////////////////////////
    // const mapToIdString = data => {
    //   return isArray(data) ? data?.map(item => item?.id?.toString()) : []
    // }

    // const matchTypeFilter = {
    //   [vehicleProducer]: !length(editData?.vehicleProducerNotIn),
    //   [vehicleModel]: !length(editData?.modelInfoNotIn),
    //   [dealerName]: !length(editData?.dealerNotIn),
    //   [dealerLocation]: !length(editData?.dealerLocationNotIn),
    // }

    // setEqualNotEqual(matchTypeFilter)

    // setSelectedFilters({
    //   [vehicleCategory]: mapToIdString(editData?.vehicleCategory),
    //   [vehicleProducer]: mapToIdString(
    //     matchTypeFilter[vehicleProducer]
    //       ? editData?.vehicleProducer
    //       : editData?.vehicleProducerNotIn,
    //   ),
    //   [vehicleModel]: mapToIdString(
    //     matchTypeFilter[vehicleModel]
    //       ? editData?.modelInfo
    //       : editData?.modelInfoNotIn,
    //   ),
    //   [vehicleSource]: mapToIdString(editData?.source),
    //   [vehicleType]: mapToIdString(editData?.vehicleType),
    //   [vehicleStatus]: editData?.currentState,
    //   [dealerName]: mapToIdString(
    //     matchTypeFilter[dealerName] ? editData?.dealer : editData?.dealerNotIn,
    //   ),
    //   [dealerLocation]: mapToIdString(
    //     matchTypeFilter[dealerLocation]
    //       ? editData?.dealerLocation
    //       : editData?.dealerLocationNotIn,
    //   ),
    //   [dealerChannel]: mapToIdString(editData?.dealerChannel),
    //   [dateOfReceiptOfVehicle]:
    //     editData?.dateOfReceiptFrom && editData?.dateOfReceiptTo
    //       ? [
    //           dayJs(editData?.dateOfReceiptFrom),
    //           dayJs(editData?.dateOfReceiptTo),
    //         ]
    //       : [],
    //   [dateOfProcessing]:
    //     editData?.dateOfProcessingFrom && editData?.dateOfProcessingTo
    //       ? [
    //           dayJs(editData?.dateOfProcessingFrom),
    //           dayJs(editData?.dateOfProcessingTo),
    //         ]
    //       : [],
    //   [dateOfReceiptOfVehicleAtCollectionCenter]:
    //     editData?.dateOfReceiptCollectionCenterFrom &&
    //     editData?.dateOfReceiptCollectionCenterTo
    //       ? [
    //           dayJs(editData?.dateOfReceiptCollectionCenterFrom),
    //           dayJs(editData?.dateOfReceiptCollectionCenterTo),
    //         ]
    //       : [],
    // })
    setColumnFilters(
      length(editData?.reportColumnMaps)
        ? editData?.reportColumnMaps?.map(item => item?.id)
        : [],
    )
  }

  const flexibleReportsFilterRequest = ({ data, matchType } = {}) => {
    const convertToNumber = value => {
      if (!value) return []
      if (Array.isArray(value)) {
        return value.map(item => Number(item))
      }
      return Number(value)
    }

    const dateFormat = date => {
      return date ? dayJs(date, SAVE_FORMAT).format(SAVE_FORMAT) : null
    }

    const payload = {
      type: 'FLEXIBLE_REPORT',
      vehicleCategory: convertToNumber(data[vehicleCategory]),
      source: convertToNumber(data[vehicleSource]),
      vehicleTypeId: convertToNumber(data[vehicleType]),
      currentState: data[vehicleStatus],
      rcAvailability: data[rcAvailability]?.length
        ? data[rcAvailability]
        : undefined,
      beneficiary: data[beneficiary] || null,
      [matchType[vehicleProducer]
        ? 'vehicleProducerId'
        : 'vehicleProducerIdNotIn']: convertToNumber(data[vehicleProducer]),
      [matchType[vehicleModel] ? 'vehicleModelId' : 'vehicleModelIdNotIn']:
        convertToNumber(data[vehicleModel]),
      [matchType[dealerName] ? 'dealerId' : 'dealerIdNotIn']: convertToNumber(
        data[dealerName],
      ),
      [matchType[dealerLocation]
        ? 'dealerLocationId'
        : 'dealerLocationIdNotIn']: convertToNumber(data[dealerLocation]),
      dealerChannelId: convertToNumber(data[dealerChannel]),
      jobCompleted: !data[jobCompleted],

      ...dateFilterItems.reduce((acc, { key }) => {
        if (data?.[key]?.[0] && data?.[key]?.[1]) {
          acc[`${key}From`] = dateFormat(data[key]?.[0])
          acc[`${key}To`] = dateFormat(data[key]?.[1])
        }
        return acc
      }, {}),
    }
    return payload
  }

  // API CALLS--------------------------------------------------------------------------
  const tagAPIFn = async () => {
    const [vehicleCategoryList, scrapSourceResp, elvSourceType, channelName] =
      await Promise.all([
        getTagListApi({ params: { type: 'VEHICLE_CATEGORY' } }), // vehicleCategory
        getTagListApi({ params: { type: 'ELV_SCRAP_SOURCE' } }), // elvScrapSource
        getTagListApi({ params: { type: 'ELV_SCRAP_TYPE' } }), // elvScrapType
        getTagListApi({ params: { type: 'CHANNEL_NAME' } }), // channelName
      ])

    dispatch(
      setOptionsList({
        vehicleCategoryList: vehicleCategoryList?.data?.list,
        scrapSourceList: scrapSourceResp?.data?.list,
        elvSourceList: elvSourceType?.data?.list,
        channelList: channelName?.data?.list,
      }),
    )
  }

  const getLocationAPI = async () => {
    const params = apiParams({ params: { type: 'CITY' } })
    const response = await getAddressDataListApi({ params })
    if (length(response?.data?.list)) {
      const locationList = response?.data?.list?.map(city => ({
        label: city?.name,
        key: city?.id,
      }))
      dispatch(
        setOptionsList({
          locationList,
        }),
      )
    }
  }

  const getVehicleModelList = async ({ pageNo = 1, search = '' }) => {
    setVehicleModelData(prev => ({ ...prev, loader: true }))
    const PAGE_SIZE = 15
    let resp
    const payload = { pageSize: PAGE_SIZE }
    if (search?.trim()) {
      payload.search = search?.trim()
      resp = await searchVehicleModelListApi({
        params: payload,
        pageNo,
      })
    } else {
      resp = await getVehicleModelListApi({
        params: payload,
        pageNo,
      })
    }

    setVehicleModelData(prev => ({
      ...resp?.data,
      list: [
        ...(notEqual(pageNo, 1) ? prev?.list : []),
        ...(resp?.data?.list || []),
      ],
      loader: false,
    }))
  }

  const debouncedGetVehicleModelList = useCallback(
    debounce(getVehicleModelList, 400),
    [],
  )

  const getProducerListAPI = async ({ pageNo = 1, search = '' } = {}) => {
    let response
    if (search?.trim()) {
      response = await searchUserApi({
        params: apiParams({
          params: {
            businessName: search,
            roleId: producer,
            userId: adminId,
          },
          pageNo,
        }),
      })
    } else {
      response = await getUserList({
        params: apiParams({
          params: { roleId: producer, userId: adminId, pageSize: 10 },
          pageNo,
        }),
      })
    }

    if (length(response?.data?.list)) {
      const optionValue = response?.data?.list?.map(({ businessName, id }) => ({
        label: t(businessName),
        value: id,
      }))
      const userList = length(producerList?.list)
        ? [...producerList?.list, ...optionValue]
        : [...optionValue]
      const searchList = search
        ? length(producerList?.searchList)
          ? [...producerList?.searchList, ...optionValue]
          : [...optionValue]
        : []

      dispatch(
        setOptionsList({
          producerList: {
            ...response?.data,
            list: search ? searchList : userList,
            searchList: searchList,
          },
        }),
      )
    }
  }

  const getDealerListAPI = async ({ pageNo = 1 } = {}) => {
    const params = {
      roleId: dealer,
      relationType: 'ASSOCIATE',
      pageSize: 10,
    }
    const response = await getUserList({
      params: apiParams({ params, pageNo }),
    })

    if (length(response?.data?.list)) {
      const optionValue = response?.data?.list?.map(({ businessName, id }) => ({
        label: t(businessName),
        value: id,
      }))
      const userList = length(dealerList?.list)
        ? [...dealerList?.list, ...optionValue]
        : [...optionValue]

      const allDealerData = length(dealerList?.allDealerData)
        ? [...dealerList?.allDealerData, ...response?.data?.list]
        : [...response?.data?.list]

      dispatch(
        setOptionsList({
          dealerList: {
            ...response?.data,
            list: userList,
            allDealerData,
          },
        }),
      )
    }
  }

  const flexibleReportColumns = {
    'MSTI Vehicle Number': {
      dataIndex: 'vehicleNumber',
      render: rowData => rowData || '-',
    },
    'Dealer Name': {
      dataIndex: ['dealerInfo', 'businessName'],
      render: rowData => rowData || '-',
    },
    Location: {
      dataIndex: ['location', 'name'],
      render: rowData => rowData || '-',
    },
    Channel: {
      dataIndex: ['channel', 'key'],
      render: rowData => rowData || '-',
    },
    'Owner Name': {
      dataIndex: ['consumer', 'lastName'],
      render: rowData => rowData || '-',
    },
    'Beneficiary Name': {
      dataIndex: 'beneficiary',
      render: rowData => rowData || '-',
    },
    'Collection Center Name': {
      dataIndex: ['collectionCenter', 'businessName'],
      render: rowData => rowData || '-',
    },
    'Aggregation Center Name': {
      dataIndex: ['collectionCenter', 'businessName'],
      render: rowData => rowData || '-',
    },
    'Maker Name': {
      dataIndex: ['producerInfo', 'businessName'],
      render: rowData => rowData || '-',
    },
    'Vehicle Registration Number': {
      dataIndex: 'vehicleRegistrationNumber',
      render: rowData => rowData || '-',
    },
    'Model Name': {
      dataIndex: ['modelInfo', 'name'],
      render: rowData => rowData || '-',
    },
    'Fuel Type': {
      dataIndex: ['vehicleFuelType', 'key'],
      render: rowData => (rowData ? t(rowData) : '-'),
    },
    'Quoted Price': {
      dataIndex: 'quotedPrice',
      isNumeric: true,
      render: fmtNum,
    },
    'Base Buying Price': {
      dataIndex: 'baseBuyingPrice',
      isNumeric: true,
      render: fmtNum,
    },
    'Dealer Commission': {
      dataIndex: 'dealerCommission',
      isNumeric: true,
      render: fmtNum,
    },
    'Special Incentive to Dealer': {
      dataIndex: 'specialIncentiveToDealer',
      isNumeric: true,
      render: fmtNum,
    },
    Freight: {
      dataIndex: 'freight',
      isNumeric: true,
      render: fmtNum,
    },
    'Total Commission': {
      dataIndex: 'job_TotalCommission',
      isNumeric: true,
      render: fmtNum,
    },
    'Picked by': { dataIndex: 'pickedBy', render: rowData => rowData || '-' },
    'Challan Deduction': {
      dataIndex: 'challanDeductions',
      isNumeric: true,
      render: fmtNum,
    },
    'Other Deduction From Customer Quoted Price': {
      dataIndex: 'deductionFromCustomerQuotedPrice',
      isNumeric: true,
      render: fmtNum,
    },
    'Other Deduction From Dealer commission': {
      dataIndex: 'deductionFromDealerCommission',
      isNumeric: true,
      render: fmtNum,
    },
    'Net amount need to be paid to the Customer': {
      dataIndex: 'netAmountToBePaidToCustomer',
      isNumeric: true,
      render: fmtNum,
    },
    'Net Net Amount need to be paid to Dealer Including Special Incentive': {
      dataIndex: 'netAmountToBePaidToDealer',
      isNumeric: true,
      render: fmtNum,
    },
    'Total Purchase Value': {
      dataIndex: 'purchasePrice',
      isNumeric: true,
      render: fmtNum,
    },
    'Other Deductions': {
      dataIndex: 'otherDeductions',
      isNumeric: true,
      render: fmtNum,
    },
    'RTO Name': { dataIndex: 'rtoName' },
    'Vehicle Category': {
      dataIndex: ['vehicleCategory', 'key'],
      render: rowData => (rowData ? t(rowData) : '-'),
    },
    Source: {
      dataIndex: ['elvSource', 'key'],
      render: rowData => (rowData ? t(rowData) : '-'),
    },
    'Vehicle Type': {
      dataIndex: ['elvScrapType', 'key'],
      render: rowData => (rowData ? t(rowData) : '-'),
    },
    'Current State': {
      dataIndex: 'currentState',
      render: rowData => (rowData ? t(rowData) : '-'),
    },
    'Date of Receipt of Vehicle': {
      dataIndex: 'dateOfReceipt',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Date of Receipt of Vehicle at Collection Center': {
      dataIndex: 'dateOfReceiptCollectionCenter',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Date of Receipt of Vehicle at Aggregation Center': {
      dataIndex: 'dateOfReceiptCollectionCenter',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Processing Date': {
      dataIndex: 'processingDate',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Date of Registration': {
      dataIndex: 'registrationDate',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Weighment at MSTI(in Kgs)': {
      dataIndex: 'weightAsPerMsti',
      isNumeric: true,
      render: fmtNum,
    },
    // 'Registration Validity': {
    //   dataIndex: 'registrationValidityDate',
    //   render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    // },
    'Picked Date': {
      dataIndex: 'pickedDate',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'MSTI Payment Date': {
      dataIndex: 'paymentDate',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Certificate of Deposit Date': {
      dataIndex: 'certificateOfDepositionDate',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Date of Dispatch': {
      dataIndex: 'vehicleDispatchDate',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    'Pre-Inspection Completed': {
      dataIndex: 'preInspectionCompleted',
      render: rowData =>
        isEqual(rowData, true)
          ? t('btn_Yes')
            ? isEqual(rowData, false)
            : t('btn_No')
          : '-',
    },
    'Date of Inspection': {
      dataIndex: 'dateOfInspection',
      render: rowData => (rowData ? dayJs(rowData).format(SAVE_FORMAT) : '-'),
    },
    Remarks: { dataIndex: 'remarks' },
    'Form2/RC Model Name': {
      dataIndex: 'vehicleModelName',
      render: rowData => rowData || '-',
    },
    'Chassis No': {
      dataIndex: 'vehicleChassisNumber',
      render: rowData => rowData || '-',
    },
    'Engine No': {
      dataIndex: 'vehicleEngineNumber',
      render: rowData => rowData || '-',
    },
    'Month/Year of Manufacture': {
      dataIndex: 'vehicleManufactureMonthYear',
      render: rowData => rowData || '-',
    },
    'Weight as per Registration certificate': {
      dataIndex: 'weightAsPerRc',
      isNumeric: true,
      render: fmtNum,
    },
    'Towing Details': {
      dataIndex: 'towingDetails',
      render: rowData => rowData || '-',
    },
    'Payment Bank Name': {
      dataIndex: 'bankName',
      render: rowData => rowData || '-',
    },
    'Payment Amount': {
      dataIndex: 'paymentAmount',
      isNumeric: true,
      render: fmtNum,
    },
    'Payment Voucher No.': {
      dataIndex: 'paymentVoucherNumber',
      render: rowData => rowData || '-',
    },
    'Certificate of Deposit No.': {
      dataIndex: 'certificateOfDepositionNumber',
      render: rowData => rowData || '-',
    },
    Category: { dataIndex: ['userCategory', 'name'] },
  }

  const columnListApi = async () => {
    const response = await getColumnListApi({
      params: apiParams({ params: { sheetType: 'FLEXIBLE_REPORT' } }),
    })
    if (length(response?.data?.list)) {
      const columnTitleOverrides = {
        beneficiary: t('job_BeneficiaryName'),
      }
      const titleIdMap = response?.data?.list?.reduce((acc, item) => {
        acc[item?.columnName] = {
          id: item?.id,
          title:
            columnTitleOverrides[item?.columnKey] ||
            item?.columnKey ||
            item?.columnName,
        }
        return acc
      }, {})

      setColumnList(
        entries(flexibleReportColumns)
          ?.map(([key, value]) => {
            return {
              key: titleIdMap[key]?.id,
              title: titleIdMap[key]?.title,
              ...value,
            }
          })
          ?.filter(({ key }) => key),
        // response?.data?.list?.map(item => {
        //   return {
        //     key: item?.id,
        //     title: item?.columnKey || item?.columnName,
        //     ...flexibleReportColumns[item?.columnName],
        //   }
        // }),
      )

      !editData?.id &&
        setColumnFilters([
          titleIdMap['MSTI Vehicle Number']?.id,
          titleIdMap['Maker Name']?.id,
          titleIdMap['Quoted Price']?.id,
        ])
    }
  }

  const onGenerateReport = async () => {
    const payload = {
      type: 'FLEXIBLE_REPORT',
      flexibleReportsFilterRequest: flexibleReportsFilterRequest({
        data: selectedFilters,
        matchType: equalNotEqual,
      }),
      columns: columnFilters,
    }

    const response = await exportToExcelApi({ payload })
    if (response?.data?.success) {
      dispatch(
        setPopupMessageModel({
          open: true,
          message: response?.data?.message,
          success: true,
        }),
      )
    }
  }

  const getFlexibleReportAPI = async ({
    pageNo = 1,
    data = selectedFilters,
    matchType = equalNotEqual,
    apiPayload,
  } = {}) => {
    const payload = apiPayload
      ? apiPayload
      : {
          flexibleReportsFilterRequest: flexibleReportsFilterRequest({
            data,
            matchType,
          }),
        }
    setFlexibleReportData(prev => ({ ...prev, loader: true }))
    try {
      const response = await getFlexibleReportDataApi({
        payload,
        pageNo,
      })
      if (response?.data) {
        setFlexibleReportData(response?.data)
        const resp = await getFlexibleReportCalculationApi({ payload })
        if (resp?.data) {
          setFlexibleReportCalculation(resp?.data)
        }
      }
    } catch (error) {
    } finally {
      setFlexibleReportData(prev => ({ ...prev, loader: false }))
    }
  }

  const handleTableChange = pagination => {
    getFlexibleReportAPI({
      pageNo: pagination?.current,
    })
  }
  const debouncedGetProducerList = useCallback(
    debounce(getProducerListAPI, 400),
    [],
  )

  //---------------------------------------------------------------------------------------------

  // const getLocationAndChannelList = (dealerList, selectedKeys) => {
  //   const location = []
  //   const channelMap = new Map()

  //   dealerList?.allDealerData?.forEach(({ id, userLocationChannelDtos }) => {
  //     if (!selectedKeys.includes(id.toString())) return

  //     userLocationChannelDtos?.forEach(
  //       ({ locationId, locationName, channels }) => {
  //         location.push({ locationId, locationName })

  //         channels?.forEach(channel => {
  //           if (!channelMap.has(channel.channelId)) {
  //             channelMap.set(channel.channelId, channel)
  //           }
  //         })
  //       },
  //     )
  //   })

  //   const uniqueChannels = Array.from(channelMap.values())

  //   return {
  //     locationList: location?.map(({ locationId, locationName }) => ({
  //       label: locationName,
  //       key: locationId,
  //     })),
  //     channelList: uniqueChannels?.map(({ channelId, channelKey }) => ({
  //       label: channelKey,
  //       key: channelId,
  //     })),
  //   }
  // }

  const handleColumnFilterChange = values => {
    setColumnFilters(
      include(values, 'txt_All') ? columnList.map(({ key }) => key) : values,
    )
  }

  const onInputChange = ({ key, value }) => {
    const tempSelectedFilters = { ...selectedFilters, [key]: value }
    setSelectedFilters(tempSelectedFilters)
    getFlexibleReportAPI({ data: tempSelectedFilters })
  }

  const onSelectionChange = ({ key, selectedKeys, type }) => {
    const modifySelectedFilters = (key, selectedKeys) => {
      const tempSelectedFilters = { ...selectedFilters }
      tempSelectedFilters[key] = selectedKeys
      setSelectedFilters(tempSelectedFilters)
      if (isEqual(key, 'dateFilter')) return

      //api call
      getFlexibleReportAPI({ data: tempSelectedFilters })
    }
    if (type === 'deselect') {
      modifySelectedFilters(key, selectedKeys)
      // if (isEqual(key, 'dealerName')) {
      //   dispatch(
      //     setOptionsList({
      //       locationList: locationList?.filter(({ locationId }) =>
      //         selectedKeys?.includes(locationId?.toString()),
      //       ),
      //       channelList: channelList?.filter(({ channelId }) =>
      //         selectedKeys?.includes(channelId?.toString()),
      //       ),
      //     }),
      //   )
      // }
    } else {
      modifySelectedFilters(key, selectedKeys)
      // if (isEqual(key, 'dealerName')) {
      //   const options = getLocationAndChannelList(dealerList, selectedKeys)
      //   dispatch(setOptionsList(options))
      // }
    }
  }

  const onEqualNotEqualChange = ({ key, value }) => {
    const updatedEqualNotEqual = { ...equalNotEqual, [key]: value }
    setEqualNotEqual(updatedEqualNotEqual)

    if (selectedFilters[key]) {
      getFlexibleReportAPI({
        data: selectedFilters,
        matchType: updatedEqualNotEqual,
      })
    }
  }

  const handleDateRangeChange = ({ key, dates }) => {
    const tempSelectedFilters = { ...selectedFilters }
    tempSelectedFilters[key] = dates
    setSelectedFilters(tempSelectedFilters)
    //api call
    getFlexibleReportAPI({ data: tempSelectedFilters })
  }

  const onScrollProcessed = ({ search = '' }) => {
    if (producerList?.lastPage > producerList?.pageNo) {
      getProducerListAPI({ pageNo: producerList?.pageNo + 1, search })
    }
  }

  const dateFilterItems = [
    {
      key: 'dateOfReceipt',
      label: t('job_DateOfReceiptOfVehicle'),
    },
    { key: 'dateOfProcessing', label: t('job_ProcessingDate') },
    {
      key: 'dateOfReceiptCollectionCenter',
      label: t('job_DateOfReceiptOfVehicleAtCollectionCenter'),
    },
    {
      key: 'dateOfRegistration',
      label: t('job_DateOfRegistration'),
    },
    {
      key: 'certificateOfDepositDate',
      label: t('job_CertificateOfDepositDate'),
    },
    {
      key: 'vehicleDispatchDate',
      label: t('job_DateOfDispatch'),
    },
    {
      key: 'dateOfInspection',
      label: t('job_DateOfInspection'),
    },
    {
      key: 'registrationValidityDate',
      label: t('job_RegistrationValidityDate'),
    },
    {
      key: 'pickedDate',
      label: t('job_PickedDate'),
    },
    {
      key: 'paymentDate',
      label: t('job_MSTIPaymentDate'),
    },
    {
      key: 'jobCompletionDate',
      label: t('job_CompletionDate'),
    },
    {
      key: 'cutoutsHandedOverDate',
      label: t('job_CutOutsHandedOverDate'),
    },
    {
      key: 'dateOfAcceptance',
      label: t('job_DateOfAcceptanceCutOuts'),
    },
    {
      key: 'dateOfDestructionCertificate',
      label: t('job_DateOfDestructionCertificateCVS'),
    },
    {
      key: 'postDate',
      label: t('job_RCPostDate'),
    },
    {
      key: 'rtoReceivedRcDate',
      label: t('inv_RCReceivedByRTODate'),
    },
  ]

  const dateFilterAttr = dateFilterItems?.reduce((acc, item) => {
    acc[item?.key] = item
    return acc
  }, {})

  const filterDropdownItems = [
    {
      key: vehicleCategory,
      label: t('vehicleCategory'),
      items: vehicleCategoryList?.map(({ key, id } = {}) => ({
        label: t(key),
        key: id,
      })),
    },
    {
      key: vehicleProducer,
      label: t('rpt_VehicleProducer'),
      items: producerList?.list?.map(({ label, value } = {}) => ({
        label,
        key: value,
      })),
      hasMatchFilter: true,
      hasSearch: true,
      onScroll: onScrollProcessed,
      onInputSearch: value => debouncedGetProducerList({ search: value }),
    },
    {
      key: vehicleModel,
      label: t('job_VehicleModel'),
      items: vehicleModelData?.list?.map(({ name, id } = {}) => ({
        label: name,
        key: id,
      })),
      hasMatchFilter: true,
      hasSearch: true,
      onScroll: ({ search }) => {
        const { pageNo, hasMore } = vehicleModelData || {}
        if (hasMore) {
          debouncedGetVehicleModelList({
            pageNo: pageNo + 1,
            search,
          })
        }
      },
      onInputSearch: value => debouncedGetVehicleModelList({ search: value }),
    },
    {
      key: vehicleSource,
      label: t('job_Source'),
      items: scrapSourceList?.map(({ key, id } = {}) => ({
        label: t(key),
        key: id,
      })),
    },
    {
      key: vehicleType,
      label: t('job_VehicleType'),
      items: elvSourceList?.map(({ key, id } = {}) => ({
        label: t(key),
        key: id,
      })),
    },
    {
      key: vehicleStatus,
      label: t('tag_CurrentState'),
      items: [
        { key: 'At Collection Center', label: 'At Aggregation Center' },
        { key: 'In Transit', label: 'In Transit' },
        { key: 'ELV Recovered', label: 'ELV Recovered' },
        { key: 'Processed', label: 'Processed' },
        {
          key: 'Processed and CVS Submitted',
          label: 'Processed and CVS Submitted',
        },
      ],
    },
    {
      key: rcAvailability,
      label: t('job_RCAvailability'),
      items: [
        { key: 'YES', label: t('btn_Yes') },
        { key: 'NO', label: t('btn_No') },
      ],
    },
    {
      key: dealerName,
      label: t('job_DealerName'),
      items: dealerList?.list?.map(({ label, value } = {}) => ({
        label,
        key: value,
      })),
      hasMatchFilter: true,
      onScroll: () =>
        dealerList?.lastPage > dealerList?.pageNo &&
        getDealerListAPI({ pageNo: dealerList?.pageNo + 1 }),
    },
    {
      key: dealerLocation,
      label: t('rpt_DealerLocation'),
      items: locationList,
      hasMatchFilter: true,
    },
    {
      key: dealerChannel,
      label: t('rpt_DealerChannel'),
      items: channelList?.map(({ key, id } = {}) => ({
        label: t(key),
        key: id,
      })),
    },
    {
      key: dateFilter,
      label: t('rpt_DateFilter'),
      items: dateFilterItems,
    },
    ...(selectedFilters?.[dateFilter]?.map(key => ({
      key,
      label: dateFilterAttr[key]?.label,
      type: 'dateRangePicker',
    })) || []),
    {
      key: jobCompleted,
      label: t('job_Status'),
      items: [
        { key: true, label: t('txt_Active') },
        { key: false, label: t('dash_Completed') },
      ],
    },
    {
      key: beneficiary,
      label: t('job_BeneficiaryName'),
      type: 'input',
      placeholder: t('job_BeneficiaryName'),
    },
    // {
    //   key: dateOfReceiptOfVehicle,
    //   label: t('job_DateOfReceiptOfVehicle'),
    //   type: 'dateRangePicker',
    // },
    // {
    //   key: dateOfProcessing,
    //   label: t('rpt_DateOfProcessing'),
    //   type: 'dateRangePicker',
    // },
    // {
    //   key: dateOfReceiptOfVehicleAtCollectionCenter,
    //   label: t('job_DateOfReceiptOfVehicleAtCollectionCenter'),
    //   type: 'dateRangePicker',
    // },
  ]

  const summaryOptions = [
    { label: 'rpt_Sum', value: 'sum' },
    { label: 'rpt_Average', value: 'avg' },
    { label: 'job_Count', value: 'count' },
  ]

  const onSaveReport = async () => {
    const { name, description } = form.getFieldsValue()
    const payload = {
      ...flexibleReportsFilterRequest({
        data: selectedFilters,
        matchType: equalNotEqual,
      }),
      name,
      description,
      flexibleReportId: editData?.id,
      columnName: columnFilters,
    }
    const response = await saveFlexibleReportApi({ payload })
    if (response?.data) {
      setModal({ open: false })
    }
  }

  const onRemoveDateFilter = dateKey => {
    const updatedFilters = {
      ...selectedFilters,
      [dateFilter]: (selectedFilters?.[dateFilter] || [])?.filter(item =>
        notEqual(item, dateKey),
      ),
      [dateKey]: null,
    }
    setSelectedFilters(updatedFilters)

    if (selectedFilters?.[dateKey]?.[0]) {
      getFlexibleReportAPI({ data: updatedFilters })
    }
  }

  return {
    form,
    modal,
    columnList,
    equalNotEqual,
    columnFilters,
    summaryOptions,
    selectedFilters,
    flexibleReportData,
    filterDropdownItems,
    viewPreviousHistory,
    flexibleReportCalculation,
    setModal,
    onSelectionChange,
    onInputChange,
    onEqualNotEqualChange,
    handleDateRangeChange,
    setViewPreviousHistory,
    handleColumnFilterChange,
    onGenerateReport,
    onSaveReport,
    handleTableChange,
    calculationTag,
    setCalculationTag,
    onRemoveDateFilter,
  }
}

export default createReport
